var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 36,
    height: 32,
    rx: 6,
    fill: "white",
    stroke: "#878787"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9116 14.979C20.0253 14.979 20.9328 15.8874 20.9328 17.0002C20.9328 18.113 20.0244 18.9924 18.9116 18.9924C17.7987 18.9924 16.9194 18.113 16.9194 17.0002C16.9194 15.8874 17.7987 14.979 18.9116 14.979ZM18.9116 9.99805C25.5331 9.99805 30.3078 16.209 30.3078 16.209C30.6303 16.6196 30.6303 17.3518 30.3078 17.7615C30.3078 17.7615 25.5322 23.9724 18.9116 23.9724C12.2909 23.9724 7.51531 17.7615 7.51531 17.7615C7.19281 17.3509 7.19281 16.6187 7.51531 16.209C7.51531 16.209 12.2909 9.99805 18.9116 9.99805ZM18.9116 22.0102C21.6659 22.0102 23.9216 19.7546 23.9216 17.0002C23.9216 14.2459 21.6659 11.9902 18.9116 11.9902C16.1572 11.9902 13.9016 14.2459 13.9016 17.0002C13.9016 19.7546 16.1572 22.0102 18.9116 22.0102Z",
    fill: "#FF671D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBox);
export default __webpack_public_path__ + "static/media/eye-box.7908813eba343a2ed67bb936ce8d7355.svg";
export { ForwardRef as ReactComponent };